import React from 'react';
import {
  Box,
  Tooltip as MuiTooltip,
  TooltipProps as MuiTooltipProps,
} from '@mui/material';
import { SystemIcon } from '@monorepo/nova-icons';
import { TooltipPlacement } from '../../../config';

export interface TooltipProps extends Omit<MuiTooltipProps, 'placement'> {
  placement?: TooltipPlacement;
  className?: string;
  severity?: 'info';
}

export const Tooltip: React.FC<TooltipProps> = ({
  className,
  severity,
  ...rest
}) => {
  const getIcon = () => {
    switch (severity) {
      case 'info':
        return <SystemIcon iconName="Info" color="inherit" size="small" />;
      default:
        return null;
    }
  };

  const getTitle = () => {
    if (!rest.title) {
      return null;
    }
    if (severity) {
      return (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {getIcon()} {rest.title}
        </Box>
      );
    }
    return rest.title;
  };

  return (
    <MuiTooltip
      {...rest}
      title={getTitle()}
      arrow
      classes={{ popper: className }}
      slotProps={{
        tooltip: {
          sx: {
            backgroundColor: (theme) => theme.palette.background.opposite,
            color: (theme) => theme.palette.text.opposite,
            fontSize: (theme) => theme.typography.body2.fontSize,
            fontWeight: (theme) => theme.typography.body2.fontWeight,
            borderRadius: (theme) => theme.customShape.borderRadiusXSmall,
          },
        },
        arrow: {
          sx: {
            color: (theme) => theme.palette.background.opposite,
          },
        },
        ...rest.slotProps,
      }}
    />
  );
};
